export const ANALYTICS_SCREEN_MANAGE_PARTNER_DETAILS = 'managePartnerDetailsScreen';
export const ANALYTICS_SCREEN_MANAGE_PARTNER_CONTACTS = 'managePartnerContactsScreen';
export const ANALYTICS_SCREEN_MANAGE_PROMOTIONS = 'managePromotionsScreen';
export const ANALYTICS_SCREEN_CREATE_PROMOTION = 'createPromotionScreen';
export const ANALYTICS_SCREEN_PROMOTION_DETAILS = 'promotionDetailsScreen';
export const ANALYTICS_SCREEN_PROMOTION_DETAILS_CODES = 'promotionDetailsCodesScreen';
export const ANALYTICS_SCREEN_PROMOTION_DETAILS_PRICING = 'promotionDetailsPricingScreen';
export const ANALYTICS_SCREEN_MANAGE_PARTNER_ADMIN = 'managePartnerAdminScreen';
export const ANALYTICS_SCREEN_MANAGE_PARTNER_PAYMENT_INFO = 'managePartnerPaymentInfoScreen';